import React from 'react'
import PropTypes from 'prop-types'
import { Textfit } from 'react-textfit'

import './ImmunizationBox.css'
import newImmunization from '../../../../../../models/Immunization/Immunization'
import withPolyglot from '../../../../../common/withPolyglot'

const STATUS_COLORS = {
  ok: '#88d76c',
  late: '#ff6b63',
  present: '#f2cb30',
  'attention': '#0a84ff',
  recommendation: '#eee'
}

function getColorForStatus (status) {
  switch (status) {
    case 'ok':
      return STATUS_COLORS.ok
    case 'late':
      return STATUS_COLORS.late
    case 'present':
      return STATUS_COLORS.present
    case 'attention':
      return STATUS_COLORS.attention
    default:
      return STATUS_COLORS.ok
  }
}

const ImmunizationBox = ({immunization, status, handleClick, translate, type, hasAdverseReaction, clickDisabled}) => {
  // TODO The immunization needs a name :)
  return <div className='uk-height-small shot-grid-cell tester'>
    <div
      className={`shot ${!clickDisabled ? 'clickable' : ''} ${type === 'immunoglobulin' ? 'immunoglobulin' : ''} ${hasAdverseReaction ? 'adverse-reaction' : ''} uk-align-center`}
      onClick={!clickDisabled ? () => handleClick() : null}
      style={{borderColor: getColorForStatus(status)}}>
      <div className='content'>
        {/* <Textfit min={14} max={16}> */}
        {/* <strong>{immunization.vaccine.name}</strong> */}
        {/* </Textfit> */}
        <Textfit min={12} max={14}>
          {immunization.getFormattedDate('pt-PT')}
        </Textfit>
        <div className={`observations-text ${hasAdverseReaction ? 'has-item-below' : ''}`}>
          <div className='hidden-on-very-small-screen'>
            <Textfit min={11} max={13}>
              {immunization.observations
                ? <strong>{translate('observations')} <span className='image-undef' data-uk-icon='icon: warning; ratio: 1' /></strong>
                : immunization.type !== 'immunoglobulin' ? <div><span className='image-undef' data-uk-icon='icon: check; ratio: 2' /></div> : null}
            </Textfit>
          </div>
        </div>
        <Textfit min={11} max={12} className={'hidden-on-very-small-screen'}>
          {hasAdverseReaction ? <strong style={{color: '#ff4d4d'}}>{translate('adverseReaction')}</strong> : null}
        </Textfit>
      </div>
    </div>
  </div>
}

ImmunizationBox.propTypes = {
  immunization: PropTypes.instanceOf(newImmunization).isRequired,
  handleClick: PropTypes.func.isRequired,
  hasAdverseReaction: PropTypes.bool,
  clickDisabled: PropTypes.bool,
  status: PropTypes.oneOf(['ok', 'late', 'recommendation', 'present', 'attention']).isRequired
}

export default withPolyglot(ImmunizationBox, 'immunizationBox')
